import React from "react";

export default function DkSablonBar({ sablonlar, disabled, onApply }) {
    return (
        <div className="flex flex-wrap gap-2">
            {(sablonlar || []).map((s) => (
                <button
                    key={s.id}
                    type="button"
                    disabled={disabled}
                    onClick={() => onApply(s)}
                    className="px-2.5 py-1.5 rounded-lg border border-white/10 text-[10px] text-slate-400 hover:border-[#D4AF37]/40 hover:text-[#F3E5AB] disabled:opacity-40"
                    title={s.aciklama}
                >
                    {s.etiket}
                </button>
            ))}
        </div>
    );
}
